export default [

  {
    value: "unassigned",
    label: "Ubekreftet",
    filterDefault: true
  },
  {
    value: "assigned",
    label: "Oppdrag bekreftet",
    filterDefault: true
  },
  {
    value: "gridPermissionApplied",
    label: "Søknad sendt til netteier",
    filterDefault: true
  },
  {
    value: "hardwareWanted",
    label: "Valgt lader kan sendes",
    filterDefault: true
  },
  {
    value: "installationDateSet",
    label: "Montering avtalt",
    filterDefault: true
  },

  {
    value: "completed",
    label: "Ferdig installert",
    filterDefault: true
  }
]


